import { Check, X } from 'lucide-react';

const POSITIVES = [
  'HIPAA-compliant infrastructure',
  'BAA available with every customer',
  'Data encrypted at rest and in transit',
  'Built on Supabase (HIPAA-eligible) and Vercel',
];

const NEGATIVES = [
  'We never share patient data with third parties',
  'We never sell aggregate data or analytics',
  'We never use patient data to train AI models',
];

const STACK = ['Supabase', 'Vercel', 'Twilio Enterprise', 'Stripe', 'Resend', 'Sentry'];

export function Trust() {
  return (
    <section className="border-y border-border bg-bg-soft py-24 md:py-32">
      <div className="container-page">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-medium uppercase tracking-wider text-primary">Trust & security</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink md:text-4xl">
            Built for the compliance officer reviewing this page.
          </h2>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2">
          <div className="rounded-2xl border border-border bg-white p-8 shadow-sm">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-primary">What we do</h3>
            <ul className="mt-6 space-y-3">
              {POSITIVES.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-ink">
                  <Check className="mt-0.5 h-4 w-4 flex-none text-primary" strokeWidth={2.25} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-border bg-white p-8 shadow-sm">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-ink-2">What we don't do</h3>
            <ul className="mt-6 space-y-3">
              {NEGATIVES.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-ink">
                  <X className="mt-0.5 h-4 w-4 flex-none text-ink-3" strokeWidth={2.25} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12">
          <p className="text-center text-xs font-medium uppercase tracking-wider text-ink-3">
            Built on infrastructure with HIPAA BAAs in place
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {STACK.map((name) => (
              <span key={name} className="text-sm font-medium text-ink-2">
                {name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
